import React from 'react';
import { useTranslation } from 'react-i18next';
import CurrencySign from './CurrencySign';

const LabelWithCurrencySignComa = ({ label, hideComma = false }) => {
  const { t } = useTranslation();

  return (
    <>
      {t(label)}
      {
        !hideComma
          ? ', '
          : null
      }
      <CurrencySign />
    </>
  );
};

export default LabelWithCurrencySignComa;
